import { useSpsLanguage } from "@spscommerce/i18n";
import React from "react";
import { PasswordIcon } from "./PasswordIcon";

export type ValidationCheck = {
    minlength: boolean;
    upper: boolean;
    lower: boolean;
    number: boolean;
    special: boolean;
};
export type StatusStateProps = {
    validationCheck: ValidationCheck;
};

export default function PasswordPolicy({ validationCheck }: StatusStateProps) {
    const { t } = useSpsLanguage();
    return (
        <>
            <p className="policy-text">
                {t("cpauth.passwordPolicy.text1", {
                    defaultValue: "Passwords must include at least:",
                })}
            </p>
            <div>
                <ul className="password-list left">
                    <li>
                        <PasswordIcon valid={validationCheck.minlength} />
                        <span
                            className={`password-text password-total-length ${
                                validationCheck.minlength ? "validated" : ""
                            }`}
                        >
                            {t("cpauth.passwordPolicy.text2", {
                                defaultValue: "8 total characters",
                            })}
                        </span>
                    </li>
                    <li>
                        <PasswordIcon valid={validationCheck.upper} />
                        <span
                            className={`password-text password-upper-case ${
                                validationCheck.upper ? "validated" : ""
                            }`}
                        >
                            {t("cpauth.passwordPolicy.text3", {
                                defaultValue: "1 uppercase letter",
                            })}
                        </span>
                    </li>
                    <li>
                        <PasswordIcon valid={validationCheck.lower} />
                        <span
                            className={`password-text password-lower-case ${
                                validationCheck.lower ? "validated" : ""
                            }`}
                        >
                            {t("cpauth.passwordPolicy.text4", {
                                defaultValue: "1 lowercase letter",
                            })}
                        </span>
                    </li>
                </ul>
                <ul className="password-list right">
                    <li>
                        <PasswordIcon valid={validationCheck.number} />
                        <span
                            className={`password-text password-number ${
                                validationCheck.number ? "validated" : ""
                            }`}
                        >
                            {t("cpauth.passwordPolicy.text5", {
                                defaultValue: "1 number",
                            })}
                        </span>
                    </li>
                    <li>
                        <PasswordIcon valid={validationCheck.special} />
                        <span
                            className={`password-text password-special ${
                                validationCheck.special ? "validated" : ""
                            }`}
                        >
                            {t("cpauth.passwordPolicy.text6", {
                                defaultValue: "1 special character",
                            })}
                        </span>
                    </li>
                </ul>
            </div>
        </>
    );
}
